import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { AuthProvider } from './contexts/AuthContext'
import { registerServiceWorker } from './pwa/register-service-worker'

/**
 * The boot screen lives in index.html, so it paints while this bundle is still
 * downloading. It hands over once React has actually painted a frame: the
 * screens take it from there with their own loading states.
 */
function dismissBootScreen(): void {
  const boot = document.getElementById('yodi-boot')
  if (!boot) return
  boot.dataset.ready = 'true'
  boot.addEventListener('transitionend', () => boot.remove(), { once: true })
  // The transition never fires when motion is reduced or the tab is hidden.
  window.setTimeout(() => boot.remove(), 800)
}

createRoot(document.getElementById("root")!).render(
  <AuthProvider>
    <App />
  </AuthProvider>
);

requestAnimationFrame(() => requestAnimationFrame(dismissBootScreen));

registerServiceWorker();
